import axios from "axios";
import authHeader from "./auth-header";

const postJsonData = async (apiURL, jsonData = {}) => {
  const finalUrl = process.env.REACT_APP_API_URL + apiURL;

  const userKeyFromStorage =
    typeof window !== "undefined" ? localStorage.getItem("userKey") : null;

  const payload = {
    ...jsonData,
    userKey: jsonData.userKey ?? userKeyFromStorage,
  };

  try {
    const response = await axios.post(`${finalUrl}?ts=${Date.now()}`, payload, {
      headers: {
        ...authHeader(),
      },
    });

    return response.data;
  } catch (error) {
    let errorMessage = "Unable to process your request. Please try later.";

    if (axios.isCancel(error)) {
      errorMessage = "Request has been canceled.";
    } else if (error.code === "ECONNABORTED") {
      errorMessage =
        "Request timed out. Please check your internet connection.";
    } else if (error.response?.data?.apiResponseMsg) {
      errorMessage = error.response.data.apiResponseMsg;
    } else if (error.message) {
      errorMessage = error.message;
    }

    return {
      apiResponseCode: "1003",
      apiResponseMsg: errorMessage,
    };
  }
};

const authservice = {
  postJsonData,
};

export default authservice;
